import React from 'react';
import PropTypes from 'prop-types';
import { PaginationWrapper, Page, PrevButton, NextButton } from './styled';

const Pagination = ({ currentPage, numberOfPages, onPrev, onNext }) => {
  return (
    <PaginationWrapper>
      <PrevButton onClick={onPrev} />
      <Page>
        {currentPage} / {numberOfPages}
      </Page>
      <NextButton onClick={onNext} />
    </PaginationWrapper>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  numberOfPages: PropTypes.number.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired
};

export default Pagination;
